<template>
	<AuthLayout>
		<template #eyebrow>Registration</template>
		<template #headline>Get started<br/>with <span class="accent">{{ appName }}.</span></template>
		<template #lead>Create an account in a minute and start managing your DOOH campaigns from a single place.</template>

		<!-- Success state -->
		<template v-if="created">
			<div class="auth-card__head" style="text-align:center;">
				<div class="auth-success-icon">
					<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
				</div>
				<h1 class="auth-card__title">Account Created!</h1>
				<p class="auth-card__subtitle">Please check your email to verify your account, then sign in.</p>
			</div>
			<router-link :to="{ name: 'v2-login' }" class="auth-btn" style="text-decoration:none;">
				Go to Sign In
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
			</router-link>
		</template>

		<!-- Registration form -->
		<template v-else>
			<div class="auth-card__head">
				<p class="auth-card__step">New account</p>
				<h1 class="auth-card__title">Create your account</h1>
				<p class="auth-card__subtitle">Free, no commitments</p>
			</div>

			<RegistrationInvitationForm
				do-create-agency
				@form-submit="registerAccount"
			/>

			<div class="auth-card__foot">
				<p>Already have an account? <router-link :to="{ name: 'v2-login' }">Sign in</router-link></p>
			</div>
		</template>
	</AuthLayout>
</template>


<script>
import PageRegistration from '@/pages/registration.vue';
import AuthLayout from './auth-layout.vue';

export default {
	name: 'V2PageRegistration',

	extends: PageRegistration,

	components: {
		...PageRegistration.components,
		AuthLayout,
	},

	computed: {
		appName() {
			return (this.$uioverrides && this.$uioverrides.name) || 'DISPL Ads';
		},
	},
};
</script>


<style lang="sass" scoped>
@import './auth-form-styles'

.auth-success-icon
	width: 64px
	height: 64px
	border-radius: 50%
	background: rgba($green, 0.15)
	color: $green
	display: flex
	align-items: center
	justify-content: center
	margin: 0 auto 16px
</style>
